/**
 * Generated by scripts/auth-route-parity.mjs. Do not edit.
 * Wave 0 Auth Finality operation catalog (live rust + embedded scan).
 */
import type { AthenaAuthGeneratedOperationDefinition } from "./operations.ts";

export const ATHENA_AUTH_OPERATIONS: AthenaAuthGeneratedOperationDefinition[] = [
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.roles.by",
    "lifecycle": "canonical",
    "method": "DELETE",
    "mutation": true,
    "operation": "authorization.roles.by",
    "path": "/authorization/roles/{id}",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "password",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "deleteUser",
    "lifecycle": "canonical",
    "method": "DELETE",
    "mutation": true,
    "operation": "deleteUser",
    "path": "/delete-user",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "",
    "path": "/",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "nonportable": true
  },
  {
    "auth": "public",
    "capability": "jwt",
    "availability": "portable",
    "embedded": "supported",
    "id": "jwt.jwks",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "jwt.jwks",
    "path": "/.well-known/jwks.json",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oauth.metadata",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "oauth.metadata",
    "path": "/.well-known/oauth-authorization-server",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "protocol",
    "capability": "oidc",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oidc.discovery",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "oidc.discovery",
    "path": "/.well-known/openid-configuration",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": false
  },
  {
    "auth": "public",
    "capability": "passkeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "passkey.relatedOrigins",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "passkey.relatedOrigins",
    "path": "/.well-known/webauthn",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.apiConfig.json",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.apiConfig.json",
    "path": "/admin/api-config.json",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "nonportable": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.athenaClient.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.athenaClient.list",
    "path": "/admin/athena-client/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.auditLog.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.auditLog.list",
    "path": "/admin/audit-log/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.authorization_server.client.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.authorization_server.client.get",
    "path": "/admin/authorization-server/client/get",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.authorization_server.client.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.authorization_server.client.list",
    "path": "/admin/authorization-server/client/list",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.authorization_server.grant.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.authorization_server.grant.list",
    "path": "/admin/authorization-server/grant/list",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.docs.html",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.docs.html",
    "path": "/admin/docs.html",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "nonportable": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailEventType.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.emailEventType.list",
    "path": "/admin/email-event-type/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailFailure.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.emailFailure.get",
    "path": "/admin/email-failure/get",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailFailure.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.emailFailure.list",
    "path": "/admin/email-failure/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailTemplate.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.emailTemplate.get",
    "path": "/admin/email-template/get",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailTemplate.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.emailTemplate.list",
    "path": "/admin/email-template/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.email.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.email.get",
    "path": "/admin/email/get",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.email.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.email.list",
    "path": "/admin/email/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.grantAssignment.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.grantAssignment.list",
    "path": "/admin/grant-assignment/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.grant.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.grant.list",
    "path": "/admin/grant/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.identity_connection.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.identity_connection.get",
    "path": "/admin/identity-connection/get",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.identity_connection.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.identity_connection.list",
    "path": "/admin/identity-connection/list",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.listUsers",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.listUsers",
    "path": "/admin/list-users",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.oauth_client.list",
    "lifecycle": "compatibility",
    "method": "GET",
    "mutation": false,
    "operation": "admin.oauth_client.list",
    "path": "/admin/oauth-client/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": false,
    "canonicalReplacement": "GET /admin/social-callback-registration/list"
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.rights.assignment.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.rights.assignment.list",
    "path": "/admin/rights/assignment/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.rights.catalog",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.rights.catalog",
    "path": "/admin/rights/catalog",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.social_callback_registration.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "admin.social_callback_registration.list",
    "path": "/admin/social-callback-registration/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": false
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "apiKey.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "apiKey.get",
    "path": "/api-key/get",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "apiKey.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "apiKey.list",
    "path": "/api-key/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.assignments.members.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "authorization.assignments.members.list",
    "path": "/authorization/assignments/members",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.assignments.users.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "authorization.assignments.users.list",
    "path": "/authorization/assignments/users",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.audit",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "authorization.audit",
    "path": "/authorization/audit",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.authoritySnapshot",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "authorization.authoritySnapshot",
    "path": "/authorization/authority-snapshot",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "oauthAuthorizationServer",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oauth.grant.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "oauth.grant.list",
    "path": "/authorization/grants",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.rights",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "authorization.rights",
    "path": "/authorization/rights",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.roles",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "authorization.roles",
    "path": "/authorization/roles",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.roles.by",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "authorization.roles.by",
    "path": "/authorization/roles/{id}",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.snapshot",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "authorization.snapshot",
    "path": "/authorization/snapshot",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "social",
    "availability": "portable",
    "embedded": "supported",
    "id": "social.callback",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "social.callback",
    "path": "/callback/{provider}",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.email.verify.change",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "user.email.verify.change",
    "path": "/change-email/verify",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "debug.schema",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "debug.schema",
    "path": "/debug/schema",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "nonportable": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "debug.schema.view",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "debug.schema.view",
    "path": "/debug/schema/view",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "nonportable": true
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "deleteUser.callback",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "deleteUser.callback",
    "path": "/delete-user/callback",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.delete.verify",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "user.delete.verify",
    "path": "/delete-user/verify",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "email.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "email.list",
    "path": "/email/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "error",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "error",
    "path": "/error",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "nonportable": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "session.get",
    "path": "/get-session",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "health",
    "availability": "portable",
    "embedded": "supported",
    "id": "health.health",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "health.health",
    "path": "/health",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "accounts",
    "availability": "portable",
    "embedded": "supported",
    "id": "account.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "account.list",
    "path": "/list-accounts",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "session.list",
    "path": "/list-sessions",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oauth.authorization.request",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "oauth.authorization.request",
    "path": "/oauth/authorize",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oauth.interaction",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "oauth.interaction",
    "path": "/oauth/interaction",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "health",
    "availability": "portable",
    "embedded": "supported",
    "id": "health.ok",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "health.ok",
    "path": "/ok",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "member.active",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "member.active",
    "path": "/organization/get-active-member",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "organization.get",
    "path": "/organization/get-full-organization",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "invitations",
    "availability": "portable",
    "embedded": "supported",
    "id": "invitation.get",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "invitation.get",
    "path": "/organization/get-invitation",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "organization.list",
    "path": "/organization/list",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "organization.authenticationPosture.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "organization.authenticationPosture.list",
    "path": "/organization/list-authentication-posture",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "invitations",
    "availability": "portable",
    "embedded": "supported",
    "id": "invitation.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "invitation.list",
    "path": "/organization/list-invitations",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "organization.lifecycleEvents.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "organization.lifecycleEvents.list",
    "path": "/organization/list-lifecycle-events",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "member.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "member.list",
    "path": "/organization/list-members",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "invitations",
    "availability": "portable",
    "embedded": "supported",
    "id": "invitation.listUser",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "invitation.listUser",
    "path": "/organization/list-user-invitations",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "passkey.register.options",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "passkey.register.options",
    "path": "/passkey/generate-register-options",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "passkey.list",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "passkey.list",
    "path": "/passkey/list-user-passkeys",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "ping",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "ping",
    "path": "/ping",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "nonportable": true
  },
  {
    "auth": "public",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "reference.openapi.json",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "reference.openapi.json",
    "path": "/reference/openapi.json",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "nonportable": true
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.password.reset.token",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "user.password.reset.token",
    "path": "/reset-password/{token}",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "protocol",
    "capability": "oidc",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oidc.userinfo",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "oidc.userinfo",
    "path": "/userinfo",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": false
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.email.verify",
    "lifecycle": "canonical",
    "method": "GET",
    "mutation": false,
    "operation": "user.email.verify",
    "path": "/verify-email",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "user.email.verify"
  },
  {
    "auth": "public",
    "capability": "health",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "health.ok.head",
    "lifecycle": "canonical",
    "method": "HEAD",
    "mutation": false,
    "operation": "health.ok.head",
    "path": "/ok",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.roles.by",
    "lifecycle": "canonical",
    "method": "PATCH",
    "mutation": true,
    "operation": "authorization.roles.by",
    "path": "/authorization/roles/{id}",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "apiKeys",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.apiKey.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.apiKey.create",
    "path": "/admin/api-key/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.athenaClient.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.athenaClient.create",
    "path": "/admin/athena-client/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.authorization_server.client.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.authorization_server.client.create",
    "path": "/admin/authorization-server/client/create",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.authorization_server.client.disable",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.authorization_server.client.disable",
    "path": "/admin/authorization-server/client/disable",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.authorization_server.client.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.authorization_server.client.update",
    "path": "/admin/authorization-server/client/update",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.authorization_server.grant.revoke",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.authorization_server.grant.revoke",
    "path": "/admin/authorization-server/grant/revoke",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.banUser",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.banUser",
    "path": "/admin/ban-user",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.createUser",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.createUser",
    "path": "/admin/create-user",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.diagnostics.avatarStorage",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.diagnostics.avatarStorage",
    "path": "/admin/diagnostics/avatar-storage",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.diagnostics.database",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.diagnostics.database",
    "path": "/admin/diagnostics/database",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailFailure.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.emailFailure.create",
    "path": "/admin/email-failure/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailFailure.delete",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.emailFailure.delete",
    "path": "/admin/email-failure/delete",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailFailure.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.emailFailure.update",
    "path": "/admin/email-failure/update",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailTemplate.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.emailTemplate.create",
    "path": "/admin/email-template/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailTemplate.delete",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.emailTemplate.delete",
    "path": "/admin/email-template/delete",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailTemplate.send",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.emailTemplate.send",
    "path": "/admin/email-template/send",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.emailTemplate.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.emailTemplate.update",
    "path": "/admin/email-template/update",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.email.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.email.create",
    "path": "/admin/email/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.email.delete",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.email.delete",
    "path": "/admin/email/delete",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "admin.email.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.email.update",
    "path": "/admin/email/update",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.grantAssignment.replaceSource",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.grantAssignment.replaceSource",
    "path": "/admin/grant-assignment/replace-source",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.grantAssignment.syncBilling",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.grantAssignment.syncBilling",
    "path": "/admin/grant-assignment/sync-billing",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.grantAssignment.syncSource",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.grantAssignment.syncSource",
    "path": "/admin/grant-assignment/sync-source",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.hasPermission",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.hasPermission",
    "path": "/admin/has-permission",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.identity_connection.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.identity_connection.create",
    "path": "/admin/identity-connection/create",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.identity_connection.disable",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.identity_connection.disable",
    "path": "/admin/identity-connection/disable",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "admin.identity_connection.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.identity_connection.update",
    "path": "/admin/identity-connection/update",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.impersonateUser",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.impersonateUser",
    "path": "/admin/impersonate-user",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.listUserSessions",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.listUserSessions",
    "path": "/admin/list-user-sessions",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.oauth_client.create",
    "lifecycle": "compatibility",
    "method": "POST",
    "mutation": true,
    "operation": "admin.oauth_client.create",
    "path": "/admin/oauth-client/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": false,
    "canonicalReplacement": "POST /admin/social-callback-registration/create"
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.removeUser",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.removeUser",
    "path": "/admin/remove-user",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.revokeUserSession",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.revokeUserSession",
    "path": "/admin/revoke-user-session",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "sessions",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.revokeUserSessions",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.revokeUserSessions",
    "path": "/admin/revoke-user-sessions",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.rights.assignment.replaceSource",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.rights.assignment.replaceSource",
    "path": "/admin/rights/assignment/replace-source",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.rights.assignment.syncBilling",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.rights.assignment.syncBilling",
    "path": "/admin/rights/assignment/sync-billing",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.rights.assignment.syncSource",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.rights.assignment.syncSource",
    "path": "/admin/rights/assignment/sync-source",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.rights.syncBilling",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.rights.syncBilling",
    "path": "/admin/rights/sync-billing",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.rights.syncSource",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.rights.syncSource",
    "path": "/admin/rights/sync-source",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.setRole",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.setRole",
    "path": "/admin/set-role",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "password",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.setUserPassword",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.setUserPassword",
    "path": "/admin/set-user-password",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.social_callback_registration.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.social_callback_registration.create",
    "path": "/admin/social-callback-registration/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": false
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.stopImpersonating",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.stopImpersonating",
    "path": "/admin/stop-impersonating",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "admin",
    "capability": "admin",
    "availability": "dedicated-only",
    "embedded": "unsupported",
    "id": "admin.unbanUser",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "admin.unbanUser",
    "path": "/admin/unban-user",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "unsupported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "apiKey.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "apiKey.create",
    "path": "/api-key/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "apiKey.create"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "apiKey.delete",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "apiKey.delete",
    "path": "/api-key/delete",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "apiKey.delete"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "apiKey.deleteExpired",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "apiKey.deleteExpired",
    "path": "/api-key/delete-all-expired-api-keys",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "apiKey.get.post",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": false,
    "operation": "apiKey.get.post",
    "path": "/api-key/get",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "apiKey.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "apiKey.update",
    "path": "/api-key/update",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "apiKey.update"
  },
  {
    "auth": "session",
    "capability": "apiKeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "apiKey.verify",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": false,
    "operation": "apiKey.verify",
    "path": "/api-key/verify",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.roles",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "authorization.roles",
    "path": "/authorization/roles",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.roles.clone",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "authorization.roles.clone",
    "path": "/authorization/roles/clone",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "social",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "callback.by",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "callback.by",
    "path": "/callback/{provider}",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.email.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.email.update",
    "path": "/change-email",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "user.email.update"
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "user.email.verify.change.post",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.email.verify.change.post",
    "path": "/change-email/verify",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.password.change",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.password.change",
    "path": "/change-password",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "user.password.change"
  },
  {
    "auth": "session",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.delete",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.delete",
    "path": "/delete-user",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "user.delete"
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.password.forget",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.password.forget",
    "path": "/forget-password",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "jwt",
    "availability": "portable",
    "embedded": "supported",
    "id": "jwt.accessToken",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "jwt.accessToken",
    "path": "/get-access-token",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.get.post",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": false,
    "operation": "session.get.post",
    "path": "/get-session",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "social",
    "availability": "portable",
    "embedded": "supported",
    "id": "account.link",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "account.link",
    "path": "/link-social",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "account.link"
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oauth.authorization.decision",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "oauth.authorization.decision",
    "path": "/oauth/authorize",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oauth.token.revoke",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "oauth.token.revoke",
    "path": "/oauth/revoke",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "protocol",
    "capability": "oauthAuthorizationServer",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oauth.token.exchange",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "oauth.token.exchange",
    "path": "/oauth/token",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "invitations",
    "availability": "portable",
    "embedded": "supported",
    "id": "invitation.accept",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "invitation.accept",
    "path": "/organization/accept-invitation",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.invitation.accept"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "member.add",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "member.add",
    "path": "/organization/add-member",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "domainEvent": "organization.member.add"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "availability": "portable",
    "embedded": "supported",
    "id": "invitation.cancel",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "invitation.cancel",
    "path": "/organization/cancel-invitation",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.invitation.cancel"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.checkSlug",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": false,
    "operation": "organization.checkSlug",
    "path": "/organization/check-slug",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "organization.create",
    "path": "/organization/create",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.create"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.delete",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "organization.delete",
    "path": "/organization/delete",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.delete"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.hasPermission",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": false,
    "operation": "organization.hasPermission",
    "path": "/organization/has-permission",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "invitations",
    "availability": "portable",
    "embedded": "supported",
    "id": "invitation.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "invitation.create",
    "path": "/organization/invite-member",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.invitation.create"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "invitation.reminder",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "invitation.reminder",
    "path": "/organization/invite-member-reminder",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "domainEvent": "organization.member.invite.reminder"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.leave",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "organization.leave",
    "path": "/organization/leave",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.member.remove"
  },
  {
    "auth": "session",
    "capability": "invitations",
    "availability": "portable",
    "embedded": "supported",
    "id": "invitation.reject",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "invitation.reject",
    "path": "/organization/reject-invitation",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.invitation.reject"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "member.remove",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "member.remove",
    "path": "/organization/remove-member",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.member.remove"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.setActive",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "organization.setActive",
    "path": "/organization/set-active",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.activeOrganization.update"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "organization.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "organization.update",
    "path": "/organization/update",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.update"
  },
  {
    "auth": "session",
    "capability": "organizations",
    "availability": "portable",
    "embedded": "supported",
    "id": "member.role.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "member.role.update",
    "path": "/organization/update-member-role",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "organization.member.role.update"
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "passkey.delete",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "passkey.delete",
    "path": "/passkey/delete-passkey",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "passkey.delete"
  },
  {
    "auth": "optional-session",
    "capability": "passkeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "passkey.authenticate.options",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "passkey.authenticate.options",
    "path": "/passkey/generate-authenticate-options",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "passkey.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "passkey.update",
    "path": "/passkey/update-passkey",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "passkey.update"
  },
  {
    "auth": "public",
    "capability": "passkeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "passkey.authenticate.verify",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "passkey.authenticate.verify",
    "path": "/passkey/verify-authentication",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.issue"
  },
  {
    "auth": "session",
    "capability": "passkeys",
    "availability": "portable",
    "embedded": "supported",
    "id": "passkey.register.verify",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "passkey.register.verify",
    "path": "/passkey/verify-registration",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "passkey.register"
  },
  {
    "auth": "session",
    "capability": "jwt",
    "availability": "portable",
    "embedded": "supported",
    "id": "jwt.refresh",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "jwt.refresh",
    "path": "/refresh-token",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.password.reset",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.password.reset",
    "path": "/reset-password",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "user.password.reset"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.revoke.others",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.revoke.others",
    "path": "/revoke-other-sessions",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.revoke"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.revoke",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.revoke",
    "path": "/revoke-session",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.revoke"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.revoke.all",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.revoke.all",
    "path": "/revoke-sessions",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.revoke"
  },
  {
    "auth": "session",
    "capability": "email",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "email.securityAlert",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "email.securityAlert",
    "path": "/send-security-alert",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "domainEvent": "user.security.alert"
  },
  {
    "auth": "session",
    "capability": "email",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "email.signIn",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "email.signIn",
    "path": "/send-sign-in-email",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true,
    "domainEvent": "user.sign-in.email"
  },
  {
    "auth": "public",
    "capability": "email",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.email.verify.send",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.email.verify.send",
    "path": "/send-verification-email",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "session.bridge.exchange",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.bridge.exchange",
    "path": "/session/bridge/exchange",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "session.bridge.issue",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.bridge.issue",
    "path": "/session/bridge/issue",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.password.set",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.password.set",
    "path": "/set-password",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.issue.email",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.issue.email",
    "path": "/sign-in/email",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.issue"
  },
  {
    "auth": "public",
    "capability": "social",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.issue.social",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.issue.social",
    "path": "/sign-in/social",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.issue"
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.issue.username",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.issue.username",
    "path": "/sign-in/username",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.issue"
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "portable",
    "embedded": "supported",
    "id": "session.revoke.current",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "session.revoke.current",
    "path": "/sign-out",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "session.revoke"
  },
  {
    "auth": "public",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.create",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.create",
    "path": "/sign-up/email",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "user.create"
  },
  {
    "auth": "public",
    "capability": "jwt",
    "availability": "portable",
    "embedded": "supported",
    "id": "jwt.token",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "jwt.token",
    "path": "/token",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "availability": "portable",
    "embedded": "supported",
    "id": "twoFactor.disable",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "twoFactor.disable",
    "path": "/two-factor/disable",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "twoFactor.disable"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "availability": "portable",
    "embedded": "supported",
    "id": "twoFactor.enable",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "twoFactor.enable",
    "path": "/two-factor/enable",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "twoFactor.enable"
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "availability": "portable",
    "embedded": "supported",
    "id": "twoFactor.backupCodes.generate",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "twoFactor.backupCodes.generate",
    "path": "/two-factor/generate-backup-codes",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "availability": "portable",
    "embedded": "supported",
    "id": "twoFactor.getUri",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": false,
    "operation": "twoFactor.getUri",
    "path": "/two-factor/get-totp-uri",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "availability": "portable",
    "embedded": "supported",
    "id": "twoFactor.emailOtp.send",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "twoFactor.emailOtp.send",
    "path": "/two-factor/send-otp",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "availability": "portable",
    "embedded": "supported",
    "id": "twoFactor.backupCodes.consume",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "twoFactor.backupCodes.consume",
    "path": "/two-factor/verify-backup-code",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "availability": "portable",
    "embedded": "supported",
    "id": "twoFactor.emailOtp.verify",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "twoFactor.emailOtp.verify",
    "path": "/two-factor/verify-otp",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "twoFactor",
    "availability": "portable",
    "embedded": "supported",
    "id": "twoFactor.verifyEnable",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "twoFactor.verifyEnable",
    "path": "/two-factor/verify-totp",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "twoFactor.enable"
  },
  {
    "auth": "session",
    "capability": "social",
    "availability": "portable",
    "embedded": "supported",
    "id": "account.unlink",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "account.unlink",
    "path": "/unlink-account",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "account.unlink"
  },
  {
    "auth": "session",
    "capability": "password",
    "availability": "portable",
    "embedded": "supported",
    "id": "user.update",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": true,
    "operation": "user.update",
    "path": "/update-user",
    "rust": "supported",
    "runtimes": {
      "dedicated": "supported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": true,
    "domainEvent": "user.update"
  },
  {
    "auth": "protocol",
    "capability": "oidc",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "oidc.userinfo.post",
    "lifecycle": "canonical",
    "method": "POST",
    "mutation": false,
    "operation": "oidc.userinfo.post",
    "path": "/userinfo",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "known",
    "sdkBindingRequired": false
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.assignments.members.replace",
    "lifecycle": "canonical",
    "method": "PUT",
    "mutation": true,
    "operation": "authorization.assignments.members.replace",
    "path": "/authorization/assignments/members/{memberId}",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.assignments.users.replace",
    "lifecycle": "canonical",
    "method": "PUT",
    "mutation": true,
    "operation": "authorization.assignments.users.replace",
    "path": "/authorization/assignments/users/{userId}",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  },
  {
    "auth": "session",
    "capability": "sessions",
    "availability": "embedded-only",
    "embedded": "supported",
    "id": "authorization.roles.by.rights",
    "lifecycle": "canonical",
    "method": "PUT",
    "mutation": true,
    "operation": "authorization.roles.by.rights",
    "path": "/authorization/roles/{id}/rights",
    "rust": "unsupported",
    "runtimes": {
      "dedicated": "unsupported",
      "embedded": "supported"
    },
    "sdkEndpoint": "missing",
    "sdkBindingRequired": true
  }
];
